import {EVENT_PREFIX} from '../../../helpers';

export default (
  {
    instanceKey
  }) => (Object.assign({
  type: `${EVENT_PREFIX}_RESET_TOUCHED`
}, {instanceKey}));
